<template>
  <div class="phone-verification-input">
    <input
      ref="input"
      :class="[statusType, size]"
      :type="type"
      :value="value"
      :maxlength="20"
      v-bind="$attrs"
      class="input"
      @input="input"
      @blur="checkHtml5Validity() && $emit('blur', $event)"
      @focus="$emit('focus', $event)">
    <phone-verification-field-countdown :phoneNumber="phoneNumber"></phone-verification-field-countdown>
  </div>
</template>

<script>

import BuefyInput from 'Root/buefy/src/components/input/Input.vue';

import PhoneVerificationFieldCountdown from './PhoneVerificationFieldCountdown';

export default {
  extends: BuefyInput,
  props: {
    phoneNumber: String
  },
  components: {PhoneVerificationFieldCountdown}
};
</script>

<style lang="scss" scoped>
.phone-verification-input {
  position: relative;

  input {
    padding-right: 30px;
  }
}
</style>
